import { Geo } from "src/gen/schema/models/global";

/**
 * Geographic region codes matching the `geo` field on UserContext.
 */
export enum GeographicRegion {
  US = "us",
  EU = "eu"
}

export type RegionInfo = {
  readonly code: GeographicRegion;
  readonly label: string;
  readonly shortLabel: string;
};

/**
 * Region metadata keyed by GeographicRegion code.
 */
export const REGIONS: Record<GeographicRegion, RegionInfo> = {
  [GeographicRegion.US]: {
    code: GeographicRegion.US,
    label: "North America/United States",
    shortLabel: "NA"
  },
  [GeographicRegion.EU]: {
    code: GeographicRegion.EU,
    label: "European Union",
    shortLabel: "EU"
  }
};

const GEO_ALIASES: Record<string, GeographicRegion> = {
  us: GeographicRegion.US,
  na: GeographicRegion.US,
  eu: GeographicRegion.EU
};

/**
 * Returns the RegionInfo for a given geo string, or undefined if unrecognized.
 * Handles both UI values ("us"/"eu") and backend values ("NA"/"EU").
 */
export const getRegionInfo = (
  geo: string | undefined
): RegionInfo | undefined => {
  if (!geo) {
    return undefined;
  }
  const key = GEO_ALIASES[geo.toLowerCase()];
  return key ? REGIONS[key] : undefined;
};

/**
 * Maps UI region selection to protobuf Geo for org APIs (e.g. NewOrgRequest.targetGeo).
 */
export const geographicRegionToGeo = (
  region: GeographicRegion | undefined
): Geo => {
  switch (region) {
    case GeographicRegion.US:
      return Geo.NA;
    case GeographicRegion.EU:
      return Geo.EU;
    default:
      return Geo.GEO_UNSPECIFIED;
  }
};
